/**
 * Canonical header carrying the caller's metaSiteId. Contract shared with the
 * growth-garage-services repo (gg-utils getMetaSiteIdFromHeaders) — a rename
 * must land in both repos together.
 */
export const WIX_META_SITE_ID_HEADER = 'x-wix-msid';
//# sourceMappingURL=msid-header.js.map